





































































import BaseComponent from '@/components/base-component.vue';
import PrescriptionAlertsMessages from '@/components/prescription/alerts/alerts-messages.vue';
import VerticalTab from '@/components/UI/vertical-tab.vue';
import { isTabletOrBelow } from '@/helpers/responsive';
import { PRESCRIPTION_VALIDATION_TYPE_ERROR } from '@/settings/consts/prescription-params';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PrescriptionAlertsCounterHeader from './alerts-counter-header.vue';

@Component({
  components: { VerticalTab, PrescriptionAlertsMessages, PrescriptionAlertsCounterHeader },
})
export default class PrescriptionAlertsDetails extends BaseComponent {
  
  @Prop()
  public data!: any;

  public isTabOpen: boolean = false;

  public alerts: any[] = [];

  get checkStatus(): string {
    const hasError = this.alerts.some(
      (item) => item.acao === PRESCRIPTION_VALIDATION_TYPE_ERROR,
    );
    return hasError ? 'error' : 'warning';
  }

  @Watch('data')
  public onChangeData(val: any): void {
    this.alerts = this.data.map((item, index) => {
      let products = [];
      if (!!item.produtosRestricao) {
        products = item.produtosRestricao.map((product) => {
          return {
            id: product.id,
            type: item.acao,
          };
        });
      }

      const log = item.log.map((l, index) => {
        return {
          id: index,
          descricao: l,
        };
      });

      return {
        ...item,
        index,
        products,
        log,
      };
    });
    this.setFirstErrors();
  }

  public onClickShowErrorProducts(val: any[]): void {
    this.isTabOpen = true;
    this.$emit('clickShowErrorProducts', val);
  }

  public onClickFocusErrorProduct(val): void {
    this.$emit('clickFocusErrorProduct', val);
    if (isTabletOrBelow()) {
      this.$emit('close');
    }
  }

  public beforeMount(): void {
    this.onChangeData(this.data);
  }

  public onClose(): void {
    this.onClickShowErrorProducts([]);
    this.$emit('close');
  }

  private setFirstErrors(): void {
    if (isTabletOrBelow()) {
      return;
    }
    if (!!this.alerts && !!this.alerts.length) {
      this.onClickShowErrorProducts(this.alerts[0].products);
    }
  }
}
